import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { ApiInfo } from 'src/app/shared/models/api-info';
import { PingResponse } from '../../models/ping-response';
import { PingApiService } from '../http/ping-api.service';

@Injectable({
    providedIn: 'root'
})
export class ApiInfoService {
    private apiInfo$: Observable<ApiInfo>;

    public constructor(private pingApiService: PingApiService) {}

    public getApiInfo(): Observable<ApiInfo> {
        if (this.apiInfo$) {
            return this.apiInfo$;
        }

        return (this.apiInfo$ = this.getCachedApiInfo());
    }

    private getCachedApiInfo(): Observable<ApiInfo> {
        return this.pingApiService.ping().pipe(
            map(
                (response: PingResponse): ApiInfo => ({
                    apiVersion: response.apiVersion,
                    isAlive: response.isAlive,
                    swaggerSpecPath: response.swaggerSpecPath
                })
            ),
            shareReplay(1)
        );
    }
}
